import { Component } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-help-videos',
  templateUrl: './help-videos.component.html',
  styleUrl: './help-videos.component.scss',
})
export class HelpVideosComponent {
  // descData = [
  //   {
  //     description: 'Alert Dashboard',
  //     url: 'https://altametricslist.com/alta-internal/Alert_Dashboard_Help.mp4',
  //   },
  //   {
  //     description: 'Health Monitoring',
  //     url: 'https://www.instagram.com/reel/DLIRME7iVoE/',
  //   },
  //   {
  //     description: 'Help Video',
  //     url: 'https://www.facebook.com/share/p/1GvX7KyR2L/',
  //   },
  // ];

  // actionOnVideo(url: string) {
  //   window.open(url, '_blank', 'width=800,height=600,top=300,left=550');
  // }
  
descData: { description: string; url: string; safeUrl?: SafeResourceUrl }[] = [];

  constructor(private sanitizer: DomSanitizer) {
    const rawData = [
      {
        description: 'Alert Dashboard',
        url: 'https://altametricslist.com/alta-internal/Alert_Dashboard_Help.mp4',
      }
    ];

    this.descData = rawData.map(video => ({
      ...video,
      safeUrl: this.getSafeUrl(video.url),
    }));
  }

  getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  onVideoPlay(event: Event): void {
  const currentVideo = event.target as HTMLVideoElement;
  const allVideos = document.querySelectorAll('video');

  allVideos.forEach(video => {
    if (video !== currentVideo) {
      video.pause();
    }
  });
}

}